// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — filled-button.classic.js, новая — filled-button.cp.js
import { isCp } from 'libs/design';
import * as classic from './filled-button.classic';
import * as cp from './filled-button.cp';

export const FilledButton = isCp ? cp.FilledButton : classic.FilledButton;
